import { render, staticRenderFns } from "./applyVolunteerSuccessPage.vue?vue&type=template&id=03b240de&scoped=true"
import script from "./applyVolunteerSuccessPage.vue?vue&type=script&lang=js"
export * from "./applyVolunteerSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./applyVolunteerSuccessPage.vue?vue&type=style&index=0&id=03b240de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b240de",
  null
  
)

export default component.exports